<template>
	
	<div class="backstage-index">
		
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper pt-0">
				<div class="content-page content-subProject">
					<div class="content">
						<div class="row row-backHome">
							<div class="col-md-6">
								<div class="row">
									<a class="col-7 a1" href="javascript:void(0)" @click="goTopicsDeclaration">
										<div class="img"><img src="@/assets/images/yf_images/backHome_01.png" alt="" /></div>
										<div class="text">
											<p>课题申报</p>
											<p>Project Application</p>
										</div>
									</a>
									<a class="col-5 a2" href="javascript:void(0)" @click="goResearchProcess">
										<div class="img"><img src="@/assets/images/yf_images/backHome_02.png" alt="" /></div>
										<div class="text">
											<p>课题管理</p>
											<p>management of research subjects</p>
										</div>
									</a>
									<a class="col-12 a3" href="javascript:void(0)" @click="goAdvancedGroup">
										<div class="img"><img src="@/assets/images/yf_images/backHome_05.png" alt="" /></div>
										<div class="text">
											<p>先进集体评选</p>
											<p>Project Management</p>
										</div>
									</a>
								</div>
							</div>

							<div class="col-md-6">
								<div class="row">
									<a class="col-6 a4" href="javascript:void(0)" @click="goResultsSelection">
										<div class="img"><img src="@/assets/images/yf_images/backHome_03.png" alt="" /></div>
										<div class="text">
											<p>征文评审</p>
											<p>Results Selection</p>
										</div>
									</a>
									<a class="col-6 a5" href="javascript:void(0)" @click="goPaperSelection">
										<div class="img"><img src="@/assets/images/yf_images/backHome_04.png" alt="" /></div>
										<div class="text">
											<p>成果评奖</p>
											<p>Advanced selection</p>
										</div>
									</a>
									<a class="col-6 a6" href="javascript:void(0)" @click="goAdvancedIndividual">
										<div class="img"><img src="@/assets/images/yf_images/backHome_06.png" alt="" /></div>
										<div class="text">
											<p>先进个人评选</p>
											<p>Scientific Research Training</p>
										</div>
									</a>
									<a class="col-6 a7" href="javascript:void(0)" @click="goSystemManagement">
										<div class="img"><img src="@/assets/images/yf_images/backHome_07.png" alt="" /></div>
										<div class="text">
											<p>系统管理</p>
											<p>System Management</p>
										</div>
									</a>
								</div>
							</div>
						</div>
						
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
		
	</div>
</template>

<script>
export default {
	data() {
		return {
			menuList: null
		};
	},
	mounted() {
		this.menuList = JSON.parse(sessionStorage.getItem('menuList'));
	},
	methods: {
		goTopicsDeclaration() {
			this.$router.push('/backstage/topicsDeclaration');
		},
		//课题管理			
		goResearchProcess() {
			// let path = this.menuList.filter(item => item.name == '课题管理')[0].children[0].path;
			// this.$router.push(`/backstage/${path}`);
			this.$router.push('/backstage/topicSummary');
		},
		goAdvancedGroup() {
			let path = this.menuList.filter(item => item.name == '先进集体评选')[0].children[0].path;
			this.$router.push(`/backstage/${path}`);
		},
		goResultsSelection() {
			console.log(this.menuList,'this.menuList')
			let path = this.menuList.filter(item => item.name == '征文评审')[0].children[0].path;
			this.$router.push(`/backstage/${path}`);
		},
		goPaperSelection() {
			let path = this.menuList.filter(item => item.name == '成果评奖')[0].children[0].path;
			this.$router.push(`/backstage/${path}`);
		},
		goAdvancedIndividual() {
			let path = this.menuList.filter(item => item.name == '先进个人评选')[0].children[0].path;
			this.$router.push(`/backstage/${path}`);
		},
		goSystemManagement() {
			if (JSON.parse(sessionStorage.getItem('userInfo')).roleId.indexOf('2') !== -1 && JSON.parse(sessionStorage.getItem('userInfo')).roleId.indexOf('5') == -1) {
				this.$router.push('/backstage/unitManagement');
			} else {
				this.$router.push('/backstage/articleManagement');
			}
		}
	}
};
</script>

<style scoped lang="scss"></style>
